import produce from 'immer';

// @ts-strict-ignore
import {ControlBarAction, ControlBarActionItems} from 'common/query-builder/query-entry-section/constants';
import {isScdProperty, Property} from 'common/query-builder/query-block/properties-menu/types';
import {SectionItem} from 'common/components/items-menu/types';
import {isTimeSeriesChartType} from 'common/report/insights/visualization/charts/chart-display/utils';
import {TimeUnit} from 'common/types/reports/bookmark';

import type {RowProps} from '../catalog';

/**
 * Displays overflow menu actions specific for simple metrics
 */
export function userMetricCustomActions(props: RowProps): SectionItem[] {
  const aggregationProperty = props.entry.measurement?.property;
  const hasSCDPropertyAggregation = isScdProperty(aggregationProperty);
  const hasSCDPropertyOffset = hasSCDPropertyAggregation && Boolean(aggregationProperty?.scdOffset);

  const handleToggleSCDPropertyOffset = () => {
    props.updateEntry(
      produce(props.entry, (draft) => {
        if (hasSCDPropertyOffset) {
          (draft.measurement.property as Property).scdOffset = undefined;
        } else {
          (draft.measurement.property as Property).scdOffset = isTimeSeriesChartType(props.sectionProps.chartType)
            ? {
                value: -1,
                unit: props.sectionProps.dateUnit as unknown as TimeUnit,
              }
            : {
                value: `$start`,
                unit: props.sectionProps.dateUnit as unknown as TimeUnit,
              };
        }
      }),
    );
  };

  return [
    hasSCDPropertyAggregation &&
      hasSCDPropertyOffset && {
        ...ControlBarActionItems[ControlBarAction.RemoveScdMeasurements],
        onSelect: handleToggleSCDPropertyOffset,
      },
    hasSCDPropertyAggregation &&
      !hasSCDPropertyOffset && {
        ...ControlBarActionItems[ControlBarAction.SetLookbackPeriod],
        onSelect: handleToggleSCDPropertyOffset,
      },
  ].filter(Boolean);
}
